export const createGhostImageContainer = () => {
  /** container for ghost image */
  const container = document.createElement('div');
  container.style.position = 'absolute';
  container.style.top = '-999px';
  container.style.left = '-999px';
  container.style.display = 'flex';
  container.style.alignItems = 'center';
  container.style.boxShadow = 'rgba(0, 0, 0, 0.35) 0px 5px 15px';

  return container;
};

export const createNumberSpan = (count: number) => {
  const span = document.createElement('span');
  span.innerText = `${count}`;
  span.style.color = 'black';
  span.style.backgroundColor = 'rgb(249, 214, 73)';
  span.style.borderRadius = '4px';
  span.style.textAlign = 'center';
  span.style.minWidth = '16px';
  span.style.padding = '2px';
  span.style.marginLeft = '10px';
  span.style.fontWeight = '600';
  span.style.fontFamily = "'Inter', 'sans-serif'";
  return span;
};

export const createImage = (src: string) => {
  const img = document.createElement('img');
  img.src = src;
  img.style.maxWidth = '80px';
  img.style.padding = '5px';
  return img;
};

export const createLeftoverSpan = (count: number) => {
  const span = document.createElement('span');
  span.innerText = `+${count}`;
  span.style.color = 'white';
  span.style.fontWeight = '600';
  span.style.fontFamily = "'Inter', 'sans-serif'";
  span.style.marginRight = '10px';
  return span;
};

export const createGhostImage = (container: HTMLElement, imagesSrc) => {
  container.innerHTML = '';
  const totalNum = imagesSrc.length;
  if (totalNum > 0) {
    if (totalNum > 1) {
      /** display number of dragged items */
      const span = createNumberSpan(totalNum);
      container.appendChild(span);
    }
    imagesSrc.forEach((src, index) => {
      if (index < 3) {
        const img = createImage(src);
        container.appendChild(img);
      }
    });

    if (totalNum > 3) {
      const leftover = createLeftoverSpan(totalNum - 3);
      container.appendChild(leftover);
    }

    document.body.appendChild(container);
  }
};
